/*eslint no-unused-vars: "off"*/
import React, { Component } from 'react'
import NavBar from './../../ui/template/NavBar'
import 'react-sortable-tree/style.css'; // This only needs to be imported once in your app
import Config from '../../config/app';
import Wizzard from "./../../ui/template/Wizzard";
import firebase from '../../config/database'
import T from './../../translations/translate'
var CryptoJS = require("crypto-js");

class Preview extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: "",
      linkToApp: ""
    }
  }



  getAppLink() {
    var _this = this;
    var linkInfo = firebase.app.database().ref('/rab_saas_site');
    linkInfo.on('value', function (snapshot) {
      _this.setState({
        linkToApp: snapshot.val().linkToPreviewApp
      })
    });
  }


  getPreviewContent() {
    var encrypted = CryptoJS.AES.encrypt(JSON.stringify({
      "iscontainer": false,
      "eventid": this.props.params.sub,
      "containerpath": "containers/max",
      "eventpath": "applist",
      "eventdatapath": "myapps"
    }), "xcape_honneygoyal");

    return (
      <div>
        {/* <p>{T.ts("Scan the qr code with this")} <a href={this.state.linkToApp.length>0?this.state.linkToApp:""} target="_blank">{T.td("preview app")}</a></p> */}
        <br />
        <img alt="" className="img" style={{ width: "250px", height: "250px" }} src={"https://api.qrserver.com/v1/create-qr-code/?size=350x350&data=" + encodeURIComponent(encrypted)} />
        <br /><br /><br />
      </div>
    )
  }


  render() {

    return (
      <div className="main-panel">
        <NavBar currentLangData={this.props.route.currentLangData}></NavBar>
        <Wizzard
          title={this.state.name ? T.td("App Preview") + ": " + this.state.name : T.td("App Preview")}
          steps={[{
            name: "preview",
            icon: "cloud_download",
            title: T.td("Preview your app"),
            active: "active",
            label1: T.ts("Just scan the QR code"),
            label2: T.ts("And preview your app"),
            content: this.getPreviewContent()
          }]}
        />
      </div>
    )
  }
}
export default Preview;


// WEBPACK FOOTER //
// ./src/containers/Builder/Preview.js